<template>
  <div class="interpretations">
    <HeadLine>
      {{$ml.get('Interpretations')}}
    </HeadLine>
    <table class="th-table">
      <tr class="head">
        <td>{{$ml.get('Element')}}</td>
        <td>{{$ml.get('Test Result')}}</td>
        <td>{{$ml.get('Interpretation')}}</td>
      </tr>
      <tr v-for="n in interpretations">
        <td>{{ n.type }}</td>
        <td>{{ processUnit(n) }}</td>
        <td 
          class="interpretation"
          :style="{
            color: $interpretationChart(n.interpretation)
          }"
        >{{ $ml.get(n.interpretation) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
export default {
  computed: {
    section() {
      return this.$root.data.tissueTest;
    },

    interpretations() {
      return [ ...this.section.data.interpretations ].sort(this.$sortNutrients('type'))
    },
  },
  methods: {
    processUnit(item) {
      const unit = [ 'N', 'P', 'K', 'Ca', 'S', 'Na', 'Cl', 'Mg' ].includes(item.type) ? '%' : 'ppm';

      return item.value.toFixed(2) + ' ' + unit;
    },
  },
  components: {
    HeadLine,
  },
}
</script>

<style lang="scss" scoped>

.interpretations {
  .interpretation {
    font-weight: bold;
  }
}

</style>